(function($) {

    /*
    *  new_map
    *
    *  This function will render a Google Map onto the selected jQuery element
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$el (jQuery element)
    *  @return	n/a
    */
    
    function new_map( $el ) {
        
        // var
        var $markers = $el.find('.marker');
        
        
        // vars
        var args = {
            zoom		: 16,
            center		: new google.maps.LatLng(0, 0),
            mapTypeId	: google.maps.MapTypeId.ROADMAP
        };
        
        
        // create map	        	
        var map = new google.maps.Map( $el[0], args);
        
        
        // add a markers reference
        map.markers = [];
        
        
        // add markers
        $markers.each(function(){
            
            add_marker( $(this), map );
            
        });

        // center map
        center_map( map );
        
        // return
        return map;
        
    }
    
    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$marker (jQuery element)
    *  @param	map (Google Map object)
    *  @return	n/a
    */
    
    function add_marker( $marker, map ) {
    
        // var
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    
        // create marker
        var marker = new google.maps.Marker({
            position	: latlng,
            map			: map,
            animation: google.maps.Animation.DROP
        });
    
        // add to array
        map.markers.push( marker );
    
        // if marker contains HTML, add it to an infoWindow
        // if( $marker.html() )
        // {
        //     // create info window
        //     var infowindow = new google.maps.InfoWindow({
        //         content		: $marker.html()
        //     });
    
          
        // }

        // open google maps with location and routing when clicked.
        google.maps.event.addListener(marker, 'click', function() {
            var maps_destination = encodeURI($marker.attr('data-lat') + ',' + $marker.attr('data-lng'));
            var maps_url = 'https://www.google.com/maps/dir/?api=1&destination=' + maps_destination;
            console.log(encodeURI(maps_url));
            window.open(maps_url, '_blank');
        });
    
    }
    
    /*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	map (Google Map object)
    *  @return	n/a
    */
    
    function center_map( map ) {
    
        // vars
        var bounds = new google.maps.LatLngBounds();
    
        // loop through all markers and create bounds
        $.each( map.markers, function( i, marker ){
    
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
    
            bounds.extend( latlng );
    
        });
    
        // only 1 marker?
        if( map.markers.length == 1 )
        {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 16 );
        }
        else
        {
            // fit to bounds
            map.fitBounds( bounds );
        }
    
    }

    /**
     * This toggles the bounce animation on a marker item
     */

    function toggleBounce(marker) {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.DROP);
          
            google.maps.event.addListener(marker, 'click', function() {
                var maps_destination = encodeURI(marker.position.lat() + ',' + marker.position.lng());
                var maps_url = 'https://www.google.com/maps/dir/?api=1&destination=' + maps_destination;
                window.open(maps_url, '_blank');
            });
        }
      }

    function scroll_to_contact_map() {
        var map = $('#clim-map');
        $('html, body').animate({
            scrollTop: map.offset().top
        }, 500);
    }
    
    /*
    *  document ready
    *
    *  This function will render each map when the document is ready (page has loaded)
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	5.0.0
    *
    *  @param	n/a
    *  @return	n/a
    */
    // global var
    var map = null;
    var clim_map = $('.clim-map--wrapper');
    
    $(document).ready(function(){

        $('.acf-map').each(function(){
            // create map
            map = new_map( $(this) );    
        });

        $('.clim-map-option--wrapper').on('click', function() {
            /*
             * Scrolls to the contact map over 0.45s
             */
            scroll_to_contact_map();
            clim_map.animate({opacity: 0}, 500)
            $('.clim-map-details--wrapper.active').removeClass('active');
            // clim_map.fadeOut(500);

            /* Hide the map */
            // clim_map.addClass('hidden');
            
            var map_index = $(this).attr('data-index');

            /**
             * This waits until the browser scroll and map hide has completed then moves it over,
             * the swap of center for the map is really jagged, simpler to just opacify it & then
             * bring it back.
             */
            setTimeout(function() {

                var marker = map.markers[map_index];
                var map_details = $('.clim-map-details--wrapper[data-clim-map-details-index="' + map_index  + '"]');
                var marker_position = marker.getPosition();
                var center = marker_position;

                map.setCenter(center);
                map.setZoom(18);
                
                /**
                 * Stop All Existing Marker Animations.
                 */
                for( var i = 0; i < map.markers.length; i++) {
                    if(map.markers[i].getAnimation() !== null) {
                        map.markers[i].setAnimation(null);
                    }
                }

                /* Re-display the map. */
                clim_map.animate({opacity: 1}, 500);
                map_details.addClass('active');

                setTimeout(function() {
                    /**
                     * Start animation for relevant marker
                     */
                    toggleBounce(marker);
                }, 600, marker);

            }, 600);

            
        })
    
    });
    
    })(jQuery);